import { useRef, useState } from 'react'
import Button from '../ui/Button'
import { useLang } from '../../contexts/LangContext'

interface AvatarUploaderProps {
  value: string
  onChange: (nextValue: string) => void
}

export default function AvatarUploader({ value, onChange }: AvatarUploaderProps) {
  const { t } = useLang()
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [loading, setLoading] = useState(false)
  const initials = t('Πρ', 'Av')

  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0]
    if (!file) return

    const reader = new FileReader()
    setLoading(true)
    reader.onload = () => {
      onChange(typeof reader.result === 'string' ? reader.result : '')
      setLoading(false)
    }
    reader.onerror = () => {
      setLoading(false)
    }
    reader.readAsDataURL(file)
  }

  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        {value ? (
          <img
            src={value}
            alt={t('Προεπισκόπηση avatar', 'Avatar preview')}
            className="h-24 w-24 rounded-[1.5rem] object-cover shadow-sm"
          />
        ) : (
          <div className="flex h-24 w-24 items-center justify-center rounded-[1.5rem] bg-slate-200 text-xl font-black text-slate-500">
            {initials}
          </div>
        )}

        <div className="flex flex-1 flex-wrap gap-3">
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="hidden"
          />
          <Button type="button" variant="secondary" loading={loading} onClick={() => inputRef.current?.click()}>
            {t('Επιλογή εικόνας', 'Choose image')}
          </Button>
          {value && (
            <Button type="button" variant="ghost" onClick={() => onChange('')}>
              {t('Αφαίρεση', 'Remove')}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
